export default "__VITE_ASSET__0874ca95__"